import {ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { FuseNavigationService } from '@fuse/components/navigation';
import { InitialData } from 'app/app.types';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.model';
import * as moment from 'moment';

@Component({
    selector     : 'classy-layout',
    templateUrl  : './classy.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./classy.component.scss']
})
export class ClassyLayoutComponent implements OnInit, OnDestroy {

    @ViewChild('avatarImg') avatarImg: ElementRef<HTMLImageElement>;

    data: InitialData;
    isScreenSmall: boolean;
    dateMax = null;
    dateMaxFinal = null;
    expirated = false;
    expiratedPayment = 0;

    paymentType = '';
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    urlAvatar = '/assets/images/avatars/nutribe.PNG';

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private _userService: UserService,
        private _changeDetectorRef: ChangeDetectorRef,
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number
    {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Subscribe to the resolved route mock-api
        this._activatedRoute.data.subscribe((data: Data) => {
            this.data = data.initialData;

            if ( this.data?.user?.avatarId ) {
                this.urlAvatar = `/api/file/download/${ this.data.user.avatarId }`;
            }

            if ( this.data.user.paymentType === 'trial' ) {
                if ( this.data.user.dateExpires ) {
                    this.paymentType = 'trial';
                    this.dateMax = moment(this.data.user.dateExpires, 'YYYY-MM-DD');
                    this.dateMaxFinal = moment(this.data.user.dateExpiresfinal, 'YYYY-MM-DD');
                    this.expirated = this.dateMax.isBefore( moment() );
                }
            }else if ( this.data.user.paymentType === 'payment' ) {
                if ( this.data.user.dateExpires ) {
                    this.paymentType = 'payment';

                    this.dateMax = moment(this.data.user.dateExpires, 'YYYY-MM-DD');
                    this.dateMaxFinal = moment(this.data.user.dateExpiresfinal, 'YYYY-MM-DD');

                    if ( this.dateMaxFinal.isBefore( moment() ) ) {
                        this.expiratedPayment = 2;
                        this.expirated = true;
                    }else if ( this.dateMax.isBefore( moment() )) {
                        this.expiratedPayment = 1;
                        this.expirated = true;
                    }else {
                        this.expiratedPayment = 0;
                        this.expirated = false;
                    }

                }
            }
        });


        // Subscribe to user changes
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) => {
                if ( user.avatarId ) {
                    this.urlAvatar = `/api/file/download/${ user.avatarId }`;
                }
            });

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) => {

                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    setFallbackAvatar(): void {
        this.urlAvatar = '/assets/images/avatars/nutribe.PNG';
        this._changeDetectorRef.detectChanges();
    }


    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void
    {
        // Get the navigation
        const navigation = this._fuseNavigationService.getComponent(name);

        if ( navigation )
        {
            // Toggle the opened status
            navigation.toggle();
        }
    }
}
